import './EmailAlertMetadataTab.scss';

import { EmailAlertRecipientsList } from '@periscopes/general/email-alerts';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SalesforceEmailTemplateRow } from '@periscopes/general/salesforce-email-templates/';
import { SalesforceEntityRow } from '@periscopes/general/entity';
import { usePeriscopeMetadata } from '@hooks';

import { COPY_SONAR_OBJECT_BASE, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSection, DetailSubsection } from '@periscopes/general';
import { PeriscopeSfEmailAlertMetadata, SonarObjectType } from '@sonar-software/sonar-ts-types';

export interface EmailAlertMetadataTabProps {
	index: number;
	sonarObjectId: number;
}

export const EmailAlertMetadataTab: React.FC<EmailAlertMetadataTabProps> = ({ index, sonarObjectId }) => {
	const { loading, metadata } = usePeriscopeMetadata<PeriscopeSfEmailAlertMetadata>(
		sonarObjectId,
		SonarObjectType.SalesforceWorkflowAlert
	);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	return (
		<DetailSection
			className='email-alert-details'
			spacing='small'>
			<DetailSubsection
				spacing='none'
				title={ COPY_SPECIFIC.OBJECT }>
				<SalesforceEntityRow
					parentIndex={ index }
					record={ {
						displayName: metadata?.parentEntityName ?? '',
						sonarObjectId: Number(metadata?.parentEntitySonarObjectId)
					} } />
			</DetailSubsection>
			<DetailSubsection
				spacing='none'
				title={ COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE }>
				<SalesforceEmailTemplateRow
					parentIndex={ index }
					record={ {
						displayName: metadata?.emailTemplateName ?? '',
						sonarObjectId: Number(metadata?.emailTemplateSonarObjectId)
					} } />
			</DetailSubsection>
			<DetailSubsection
				hidden={ !metadata?.recipients.length }
				spacing='none'
				title={ COPY_SPECIFIC.RECIPIENTS }>
				<EmailAlertRecipientsList
					parentIndex={ index }
					recipients={ metadata?.recipients ?? [] } />
			</DetailSubsection>
			<DetailSubsection
				spacing='none'
				title={ COPY_SPECIFIC.CC_EMAILS }>
				<div className='cc-emails'>{ metadata?.ccEmails }</div>
			</DetailSubsection>
		</DetailSection>
	);
};
